import React from 'react';
import { DocumentGenerationModal, type IDocumentGenerationModalProps } from '~/modules/covenants/CovenantsDataApplicationForm/components/DocumentGenerationModal.tsx';
import { DocumentGenerationHistoryModal } from '~/modules/covenants/CovenantsDataApplicationForm/components/documentGenerationHistory/DocumentGenerationHistoryModal.tsx';
import { useDocumentGenerationFlow } from '~/modules/covenants/CovenantsDataApplicationForm/hooks/useDocumentGenerationFlow.ts';
import type {
  TApiApplicationDocument,
  TApplicationDocumentHistoryResponse,
} from '~/modules/covenants/types.ts';

type TDocumentGenerationFlow = Pick<
  ReturnType<typeof useDocumentGenerationFlow>,
  | 'isGenerationModalOpen'
  | 'isHistoryModalOpen'
  | 'historicalBody'
  | 'regenerationSource'
  | 'stateAidCertificateType'
  | 'setStateAidCertificateType'
  | 'isRegenerationTypeSelection'
  | 'openHistoricalDocument'
  | 'openNewDocument'
  | 'openRegenerationWithType'
  | 'closeGeneration'
  | 'closeHistory'
>;

interface IDocumentGenerationDialogsProps {
  document: TApiApplicationDocument;
  flow: TDocumentGenerationFlow;
  modalProps: Omit<
    IDocumentGenerationModalProps,
    'open' | 'documentId' | 'documentName' | 'historicalBody' | 'regenerationSource' | 'onClose'
  >;
  onLoadHistory: (
    page: number,
    size: number
  ) => Promise<TApplicationDocumentHistoryResponse | null>;
  requiresStateAidType: boolean;
}

export const DocumentGenerationDialogs: React.FC<IDocumentGenerationDialogsProps> = ({
  document,
  flow,
  modalProps,
  onLoadHistory,
  requiresStateAidType,
}) => {
  return (
    <>
    <DocumentGenerationHistoryModal
      open={flow.isHistoryModalOpen}
      documentName={document.documentName}
      onClose={flow.closeHistory}
      onLoad={onLoadHistory}
      onSelect={flow.openHistoricalDocument}
      onCreateNew={flow.openNewDocument}
      requiresStateAidType={requiresStateAidType}
      stateAidCertificateType={flow.stateAidCertificateType}
      onStateAidCertificateTypeChange={flow.setStateAidCertificateType}
      isRegenerationTypeSelection={flow.isRegenerationTypeSelection}
      onRegenerate={flow.openRegenerationWithType}
    />
    <DocumentGenerationModal
      {...modalProps}
      open={flow.isGenerationModalOpen}
      documentId={document.documentId}
      documentName={document.documentName}
      historicalBody={flow.historicalBody}
      regenerationSource={flow.regenerationSource}
      onClose={flow.closeGeneration}
    />
    </>
  );
};
